import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../assets/img/logo4.jpeg';
import paymenticon from '../assets/img/payment-methods.png';
import { FOOTER_LINK_MAP } from './FooterPages/footerRoutes';

const LINKS = {
    'Useful Links': ['Documentation', 'Support', 'Privacy & Terms', 'Sitemap', 'Customers'],
    'Help':         ['Home', 'About Us', 'Business Partnership', 'Blogs', 'Contact Us'],
    'Policy':       ['Privacy Policy', 'Terms and Conditions', 'Return Policy', 'Refund Policy', 'IP Policy'],
};

const SOCIALS = [
    { icon: 'fa-facebook-f',  label: 'Facebook'  },
    { icon: 'fa-google',      label: 'Google'     },
    { icon: 'fa-pinterest-p', label: 'Pinterest'  },
    { icon: 'fa-linkedin-in', label: 'LinkedIn'   },
    { icon: 'fa-dribbble',    label: 'Dribbble'   },
];

function Footer() {
    return (
        <Wrap>
            <div className="ft-main">
                <div className="ft-inner">

                    {/* ── Brand column ── */}
                    <div className="ft-brand">
                        <img src={logo} alt="Coliza" className="ft-logo" />
                        <p className="ft-desc">
                            Your trusted online pharmacy — delivering quality medicines &amp; health products right to your door, safely and swiftly.
                        </p>
                        {/* <div className="ft-socials">
                            {SOCIALS.map((s) => (
                                <a key={s.label} href="#" className="ft-social" aria-label={s.label}>
                                    <i className={`fab ${s.icon}`} />
                                </a>
                            ))}
                        </div> */}
                    </div>

                    {/* ── Link columns ── */}
                    {Object.entries(LINKS).map(([heading, items]) => (
                        <div className="ft-col" key={heading}>
                            <h6 className="ft-heading">{heading}</h6>
                            <ul className="ft-list">
                                {items.map((item) => (
                                    <li key={item}>
                                        <Link to={FOOTER_LINK_MAP[item] || '/'} className="ft-link">{item}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Bottom bar ── */}
            <div className="ft-bottom">
                <div className="ft-inner ft-bottom-inner">
                    <p className="ft-copy">Copyright &copy; 2023 Coliza | All rights reserved.</p>
                    <img src={paymenticon} alt="Payment methods" className="ft-payment" />
                </div>
            </div>
        </Wrap>
    );
}

export default Footer;

const Wrap = styled.footer`
    background: #ffffff;
    font-family: 'Inter', 'Segoe UI', -apple-system, sans-serif;

    /* shared max-width wrapper */
    .ft-inner {
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;
    }

    /* ════════════════════════════
       Main section
    ════════════════════════════ */
    .ft-main {
        padding: 72px 0 64px;
    }

    .ft-inner {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr 1fr;
        gap: 48px;

        @media (max-width: 992px) {
            grid-template-columns: 1fr 1fr;
            gap: 36px;
        }
        @media (max-width: 576px) {
            grid-template-columns: 1fr;
            gap: 32px;
        }
    }

    /* ── Brand ── */
    .ft-brand {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .ft-logo {
        height: 48px;
        width: auto;
        object-fit: contain;
        align-self: flex-start;
        border-radius: 6px;
    }

    .ft-desc {
        font-size: 14px;
        line-height: 1.75;
        color: #6B7280;
        margin: 0;
        max-width: 300px;
    }

    /* Social icons — horizontal row */
    .ft-socials {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .ft-social {
        width: 34px;
        height: 34px;
        border-radius: 8px;
        border: 1.5px solid #E5E7EB;
        background: #F9FAFB;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #6B7280;
        font-size: 13px;
        text-decoration: none;
        transition: background 0.18s, color 0.18s, border-color 0.18s, transform 0.2s;

        &:hover {
            background: #2563eb;
            border-color: #2563eb;
            color: #ffffff;
            transform: translateY(-2px);
            text-decoration: none;
        }
    }

    /* ── Link columns ── */
    .ft-col {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .ft-heading {
        font-family: 'Poppins', 'Segoe UI', sans-serif;
        font-size: 13.5px;
        font-weight: 600;
        font-style: normal;
        letter-spacing: 0.01em;
        text-transform: none;
        color: #111827;
        margin: 0;
        padding-bottom: 14px;
        border-bottom: 2px solid #2563eb;
        display: inline-block;
        width: 100%;
    }

    .ft-list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 11px;
    }

    .ft-link {
        font-size: 13.5px;
        color: #4B5563;
        text-decoration: none;
        transition: color 0.15s, padding-left 0.15s;
        display: inline-block;

        &:hover {
            color: #2563eb;
            padding-left: 4px;
            text-decoration: none;
        }
    }

    /* ════════════════════════════
       Bottom bar
    ════════════════════════════ */
    .ft-bottom {
        border-top: 1px solid #F3F4F6;
        padding: 20px 0;

        /* reset the grid from .ft-inner above */
        .ft-inner {
            display: flex !important;
            grid-template-columns: unset;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 12px;
        }
    }

    .ft-copy {
        font-size: 13px;
        color: #9CA3AF;
        margin: 0;
    }

    /* Payment icons — grayscale by default, color on hover */
    .ft-payment {
        height: 24px;
        width: auto;
        object-fit: contain;
    }
`;
